import {
  GET_ALL_PENDING_POD_SUMMARY_AR_REQUEST,
  GET_ALL_PENDING_POD_SUMMARY_AR_SUCCESS, 
  GET_ALL_PENDING_POD_SUMMARY_AR_ERROR  
  } from "../actions/types";
  
  export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
      case GET_ALL_PENDING_POD_SUMMARY_AR_REQUEST:
        return {
          loading: true,
        };
      case GET_ALL_PENDING_POD_SUMMARY_AR_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_ALL_PENDING_POD_SUMMARY_AR_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };
  